import {Grid, Paper} from '@material-ui/core';
import {P, H5} from 'components/TypographyShortcuts';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {usePutProfile} from 'hooks/usePutEndpoint';
import {useGetProfile} from 'hooks';
import {useContext} from 'react';
import {UserContext} from 'context/UserContext';

const useStyles = makeStyles(theme => ({
    paper: {
        backgroundColor:
            theme.palette.type === 'dark'
                ? theme.palette.gray.light2
                : theme.palette.primary.light4,
        maxWidth: '12em',
        minHeight: '8em',
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover,&:focus': {
            backgroundColor:
                theme.palette.type === 'dark'
                    ? theme.palette.primary.light
                    : theme.palette.primary.light3,
        },
    },
    paperHighlighted: {
        backgroundColor:
            theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : theme.palette.primary.light,
    },
}));

const HasMMCPage = ({hasMMC, setHasMMC, goNextPage}) => {
    const classes = useStyles();
    const {data: profile} = useGetProfile();
    const {put} = usePutProfile();
    const {updateProfile} = useContext(UserContext);

    const handleUpdateHasMMC = has => {
        put({...profile, applicant_previous_mmc: has});
        updateProfile({applicant_previous_mmc: has});
        setHasMMC(has);
        goNextPage();
    };

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <P align='center' key={1}>
                    Do you currently or have you ever had an MMC before?
                </P>
            </Grid>
            <Grid item xs={12}>
                <Paper
                    elevation={3}
                    className={clsx(classes.paper, {
                        [classes.paperHighlighted]: hasMMC,
                    })}
                    onClick={() => handleUpdateHasMMC(true)}
                >
                    <H5>Yes</H5>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper
                    elevation={3}
                    className={clsx(classes.paper, {
                        [classes.paperHighlighted]: hasMMC === false,
                    })}
                    onClick={() => handleUpdateHasMMC(false)}
                >
                    <H5>Not Yet</H5>
                </Paper>
            </Grid>
        </Grid>
    );
};
export default HasMMCPage;
